{
  "title": "Переходимо до запитань",
  "desc": "Далі — кілька блоків про самопочуття, енергію, стосунки та інші важливі аспекти вашого стану. Відповіді займуть приблизно 5–15 хвилин. \n\nВідповідайте в спокійному темпі й чесно — це допоможе краще зрозуміти, що зараз є основним ресурсом, а що потребує трохи більше уваги. \nВід цього залежить, які рекомендації ви отримаєте наприкінці.",
  "buttonHome": "На головний екран",
  "buttonNext": "Далі"
}
